const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightTopWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.842 0.659 74.239 116.158",
    width: 74.239,
    height: 116.158,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "3.891 11.825 1.322 71.181 19.165 69.781 27.014 8.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "1.375 75.355 0.842 116.817 13.195 115.34 18.476 75.372"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "18.423 114.653 25.435 75.79 51.947 75.412 41.727 111.047"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "26.893 69.26 39.924 6.618 75.081 0.659 54.097 66.914"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTopWindow);
export default __webpack_public_path__ + "static/media/RightTopWindow.79cd9daa4a6a6840cf59fb5a09cefb3a.svg";
export { ForwardRef as ReactComponent };